import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import MarketingTextBlockData from 'app/Models/Content/MarketingTextBlockData';
import TVLobbyPageData from 'app/Models/Content/TVLobbyPageData';
import Lobby from 'app/Components/Shared/Lobby';
import React from 'react';
import StickyHeader from './StickyHeader';
import {isMobile} from 'react-device-detect';
import {getImageProps, getVideoLink} from 'app/utilities/ImageProps';

export default class TVLobbyPage extends Page<TVLobbyPageData> {

  render() {
    const {
      data: {
        backgroundVideo,
        backgroundImage,
        mobileBackgroundImage,
        mobileBackgroundVideo,
        marketingTextsContentArea,
        desktopMarketingTextsContentArea,
        mainContentArea,
        titleHeadlineTag,
        isShowHeaderButton,
        headerButtonLink,
        blockButton,
      },
      context,
    } = this.props;

    const teaserTexts =
      !isMobile && desktopMarketingTextsContentArea.expandedValue
        ? desktopMarketingTextsContentArea.expandedValue.map(({text, highlightText}: MarketingTextBlockData) => ({
            text: text.value,
            highlightText: highlightText.value,
          }))
        : marketingTextsContentArea.expandedValue.map(({text, highlightText}: MarketingTextBlockData) => ({
            text: text.value,
            highlightText: highlightText.value,
          }));

    const videoUrl = isMobile ? getVideoLink(mobileBackgroundVideo, context) : getVideoLink(backgroundVideo, context);
    const imageUrl = isMobile ? getImageProps(mobileBackgroundImage, context) : getImageProps(backgroundImage, context);
    return (
      <Lobby className='TVLobbyPage'>
        <StickyHeader
          titleHeadlineTag={titleHeadlineTag}
          videoUrl={videoUrl}
          fallbackImage={imageUrl}
          texts={teaserTexts}
          isTvContent={false}
          isShowHeaderButton={isShowHeaderButton}
          headerButtonLink={headerButtonLink}
          context={context}
          blockButton = {blockButton}
          
        />

        <ContentArea noWrap data={mainContentArea} context={context} />
      </Lobby>
    );
  }
}
